module.exports = __webpack_public_path__ + "img/diagram-nested.d49c55c7.svg";